module.exports = __webpack_public_path__ + "img/userpic_undefined_daskipper.340c8e4d.png";